<tr
  class="table-body-row"
  *ngIf="!form && !sendData"
  [title]="title"
  [class.table-body-row--expandable]="expandableTable && !expanded"
  [class.disabled]="disabled"
  [class.highlight]="highlight"
>
  <sp-table-body-cell *ngIf="withCheckbox" class="custom-width">
    <sp-controls type="checkbox" [checked]="rowsCheck" (change)="onToggleRowCheckox($event)"> </sp-controls>
  </sp-table-body-cell>
  <ng-template [ngIf]="cells">
    <ng-template ngFor let-cell [ngForOf]="cells">
      <sp-table-body-cell
        [cell]="cell"
        [buttons]="buttons"
        [expandRow]="expandRow"
        [row]="this"
        [expandableTable]="expandableTable"
        [expanded]="expanded"
      ></sp-table-body-cell>
    </ng-template>
  </ng-template>
  <ng-content></ng-content>
</tr>

<sp-table-body-row-form
  *ngIf="cells && form"
  [sendData]="sendData"
  [form]="form"
  [cells]="cells"
  [formGroup]="formGroup"
  [DataService]="DataService"
  [cancelTableForm]="cancelTableForm"
  [row]="this"
></sp-table-body-row-form>
<sp-table-body-row-extended
  *ngIf="expanded"
  [expandableTable]="expandableTable"
  [expanded]="expanded"
  [query]="query"
  [basicQuery]="basicQuery"
  [cells]="cells"
></sp-table-body-row-extended>
